import * as types from './board.types';
import * as constants from './board.constants';
import { generateClearResourceAction, generateStoreResourceAction } from '../../generators/resource.actions';

export const storeBoard = generateStoreResourceAction<types.IBoard>(constants.STORE_BOARD);
export const clearBoard = generateClearResourceAction(constants.CLEAR_BOARD);
